// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2naIy","large":"styles_large__Elcxp"};